module.exports = __webpack_public_path__ + "img/project5_2.jpg.715c2da0.webp";